import React, { useEffect, useState } from "react";
import { RunnerUpHeader } from "../../../ui";
import SelectField from "../../../library/components/Select";
import { useGetEpbScanningDeoReportQuery } from "../../../services/reportsServices";
import pdfIcon from "../../../images/pdfIcon.png"
import excelIcon from "../../../images/excelIcon.png"
import Table from "../../../ui/datatable/DataTable";
import { downloadExcelFile, downloadPdfFile } from "../../utilities/utils"
import { useDispatch } from "react-redux";
import LeftMenu from "../../AnalyticsModule/Left";
import RunnerUpHeaderNew from "../../../ui/runnerUpHeader/RunnerUpHeaderNew";


const selectConstituencyType = [
  { value: "AC", label: "AC" },
  { value: "PC", label: "PC" },
];
const EpbScanningDeoReport = () => {
  const [totalNoOfRecords, setTotalNoOfRecords] = useState()
  const [data, setData] = useState({
    constituencyType: "AC",
  });
  const reportName = "e-Postal Ballot PreCounting Report"
  const SheetName = "Scanning Report"
  const [tabledata, setTabledata] = useState([]);
  const [skip, setskip] = useState(false);
  const tableHeader = [];
  const columns = [
    {
      Header: "State Name",
      accessor: "col1",
    },
    {
      Header: "District No. and Name",
      accessor: "col2",
    },
    {
      Header: "AC/PC No. and Name",
      accessor: "col3",
    },
    {
      Header: "Total e-PB valid",
      accessor: "col4",
    },
    {
      Header: "Total e-PB invalid",
      accessor: "col5",
    },
    {
      Header: "Total e-PB manually Rejected",
      accessor: "col6",
    },
    {
      Header: "Total e-PB found duplicate",
      accessor: "col7",
    },
    {
      Header: "Incomplete Scanned",
      accessor: "col8",
    },
    {
      Header: "Total e-PB Scannned",
      accessor: "col9",
    },

  ];
  columns.map((item) => {
    tableHeader.push(item.Header)
  })

  const { data: GetEpbScanningDeoReport ,isSuccess} = useGetEpbScanningDeoReportQuery(
    data.constituencyType
  ); 

  const handleChange = (key, val) => {
    setData((prevState) => ({
      ...prevState,
      [key]: val,
    }));
  };

  useEffect(() => {
    var tableData = [];
    if (GetEpbScanningDeoReport !== null) {
      GetEpbScanningDeoReport?.payload?.map((item) => {
        tableData.push({
          "col1": item.stateName,
          "col2": `${item.districtCd}-${item.districtName}`,
          "col3": `${item.acPcNo}-${item.acPcName}`,
          "col4": item.validEpbScannigCount,
          "col5": item.invalidEpbScannigCount,
          "col6": item.manuallyRejectedEpbCount,
          "col7": item.duplicateEpbScannigCount,
          "col8": item.incompleteCount,
          "col9": item.totalCount,
        });
      });
      setTabledata(tableData);
      setTotalNoOfRecords(GetEpbScanningDeoReport?.payload?.length)
      setskip(true);
    }
  }, [GetEpbScanningDeoReport]);
  
  return (
    <>
      <LeftMenu>
      <div className="container box shadow ">
      <RunnerUpHeaderNew title={reportName} 
      state={<span
                  >
                    State: {GetEpbScanningDeoReport?.state}{" "}
                    <span style={{ marginLeft: "13px" }}></span>District :{" "}
                    {GetEpbScanningDeoReport?.district}
                    </span>}
        
      onPdfClick={() => downloadPdfFile(reportName, tableHeader, tabledata, false, true)}
      onExcelClick={() => downloadExcelFile(reportName, SheetName, tableHeader, tabledata, true)}
      />
        <div className="row">
          <SelectField
            labelClass=""
            inputClass="col-md-2"
            options={selectConstituencyType}
            value={data.constituencyType}
            handleChange={(val) => handleChange("constituencyType", val)}
          ></SelectField>
        </div>
        <div style={{ marginTop: "-40px" }}>
        <Table
          placeholder="Search"
          globalsearch={true}
          selectall={true}
          columns={columns}
          emptyMessage="No Record Found"
          data={tabledata?.length === 0 ? [] : tabledata}
          size={5}
          tableClassNameCheck="contenttable-eroll"
          pagination
          records
          gotopage
          rows
          numberrows={totalNoOfRecords}
        />
      </div>
      </div>
      </LeftMenu>
    </>
  );
};

export default EpbScanningDeoReport;
